import React, { Component } from 'react';
import classNames from 'classnames';
import { ChevronDown, ChevronRight, ChevronLeft } from 'react-feather';
import OutsideClickHandler from 'react-outside-click-handler';
import { getPaginationState, savePaginationState } from 'utils/tableStorage';


class Pagination extends Component {
  constructor(props) {
    super(props);
    
    // Load saved pagination state from localStorage if tableId is provided
    let initialLimit = props.limit || 10;
    let initialPage = 1;
    
    if (props.tableId) {
      const savedState = getPaginationState(props.tableId);
      if (savedState) {
        initialLimit = savedState.limit || initialLimit;
        initialPage = savedState.currentPage || initialPage;
        
        // Notify parent of loaded state
        if (props.onLoadSavedState) {
          props.onLoadSavedState(initialPage, initialLimit);
        }
      }
    }
    
    this.state = {
      showPageLimit: false,
      totalPage: 30,
      limit: initialLimit,
      currentPage: initialPage,
    };
  }

  getSnapshotBeforeUpdate(prevProps) {
    const { limit } = this.props;

    if (limit !== prevProps.limit) {
      return limit;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null) {
      this.setState({ limit: snapshot });
    }
    if (this.props.currentPage !== prevProps.currentPage) {
      this.setState({ currentPage: this.props.currentPage })
    }
  }

  hidePageLimit = () => {
    this.setState({ showPageLimit: false });
  };

  showPageLimit = (e) => {
    this.setState({ showPageLimit: true });
  };

  setCurrentPage = (currentPage) => {
    this.setState({ currentPage }, () => {
      // Save to localStorage if tableId is provided
      if (this.props.tableId) {
        savePaginationState(this.props.tableId, currentPage, this.state.limit);
      }
    });
    this.props.setCurrentPage(currentPage);
  }

  onPrevious = () => {
    if (this.props.currentPage !== 1) {
      const newPage = this.props.currentPage - 1;
      this.setState({ currentPage: newPage }, () => {
        // Save to localStorage if tableId is provided
        if (this.props.tableId) {
          savePaginationState(this.props.tableId, newPage, this.state.limit);
        }
      });
      this.props.setCurrentPage(newPage);
    }
  }

  onNext = () => {
    const { limit, totalPage, currentPage } = this.props;

    if ((currentPage * limit) < totalPage) {
      const newPage = currentPage + 1;
      this.setState({ currentPage: newPage }, () => {
        // Save to localStorage if tableId is provided
        if (this.props.tableId) {
          savePaginationState(this.props.tableId, newPage, this.state.limit);
        }
      });
      this.props.setCurrentPage(newPage);
    }
  }

  setLimit = (payload, e) => {
    this.setState({ limit: payload, currentPage: 1 }, () => {
      // Save to localStorage if tableId is provided
      if (this.props.tableId) {
        savePaginationState(this.props.tableId, 1, payload);
      }
    });
    this.props.onChangeLimit(payload);
  }

  render() {
    const { limit } = this.state;
    const { totalPage, currentPage, hideDivider, minVisibleThreshold, dropUp } = this.props;
    const totalLimit = limit * currentPage;
    const threshold = typeof minVisibleThreshold === 'number' ? minVisibleThreshold : 10;

    // Only show pagination when total items exceed the minimum threshold
    if (totalPage <= threshold) {
      return <span />
    }

    return (
      <>
        {!hideDivider && <hr className="pagination-hr" />}
        <div className="pagination" onMouseDown={(e) => {
          e.stopPropagation(); // Prevents drag start
        }}>
          <OutsideClickHandler onOutsideClick={this.hidePageLimit}>
            <span className="pagination-item">Items per page</span>
            <span className="pagination-page-section">
              <span
                className="pagination-page-limit"
                onClick={this.showPageLimit}
              >
                <span className="current-page">{limit}</span>
                <span className="pagination-svg">
                  <ChevronDown size={16} />
                </span>
              </span>
              {this.state.showPageLimit && (
                <div
                  className={classNames("pagination-selector", dropUp && "pagination-selector--drop-up")}
                  onClick={this.hidePageLimit}
                >
                  <h4 className="pagination-selector-item" onClick={() => this.setLimit(10)}>10</h4>
                  <h4 className="pagination-selector-item" onClick={() => this.setLimit(25)}>25</h4>
                  <h4 className="pagination-selector-item" onClick={() => this.setLimit(50)}>50</h4>
                  <h4 className="pagination-selector-item" onClick={() => this.setLimit(100)}>100</h4>
                </div>
              )}
            </span>
            <span className="pagination-info">
              {((currentPage - 1) * limit) + 1}
              -
              {totalPage > totalLimit ? totalLimit : totalPage}
              {' '}
              of
              {' '}
              {totalPage}
            </span>
            {' '}
            <span
              className={classNames('pagination-prev', {
                'pagination-disabled': currentPage === 1,
              })}
              onClick={this.onPrevious}
            >
              <ChevronLeft size={16} />
            </span>
            <span
              onClick={this.onNext}
              className={classNames('pagination-next', {
                'pagination-disabled': (totalLimit) >= totalPage,
              })}
            >
              <ChevronRight size={16} />
            </span>
          </OutsideClickHandler>
        </div>
      </>
    );
  }
}

export default Pagination;
